import React from 'react';
import FlexBox from 'components/UI/Layout/FlexBox';
import { FontSize, Spacing, IconSize } from 'modules/styles/variables';
import { MuiTypography } from 'theme/material-ui';
import Divider from 'components/UI/Divider';
import { VerticalDivider } from 'components/UI/Divider/styled';
import { Color } from 'modules/styles/colors';
import { Svg } from 'components/UI/Svg/';
import { history } from 'lib/history';
import { StyledMuiButton } from './styled';

const MyCareTeamHeader = () => {
  return (
    <>
      <FlexBox flexDirection="row" height={50}>
        <FlexBox spacing={Spacing.large} flexDirection="row" alignItems="center" flex={1}>
          <MuiTypography variant="subtitle2">My Care Team</MuiTypography>
        </FlexBox>
        <VerticalDivider style={{ height: 'auto' }} />
        <StyledMuiButton
          onClick={() => history.push('/u/find-a-doctor')}
          data-testid="find-care-team-button"
        >
          <Svg name="search" set="material" size={IconSize.base} />
          <MuiTypography
            fontSize={FontSize.small}
            color={Color.black}
            style={{ marginLeft: Spacing.small }}
          >
            Find Care Team
          </MuiTypography>
        </StyledMuiButton>
      </FlexBox>
      <Divider />
    </>
  );
};

export default MyCareTeamHeader;
